import reduce from 'lodash/reduce';
import isObject from 'lodash/isObject';
import mapKeys from 'lodash/mapKeys';
import get from 'lodash/get';

import {getDistance} from '~/misc/geo';
import {humanLowerCaseToId} from '~/misc/equipment';
import loadFromState from '~/misc/loadFromState';

const toValue = (obj) => {
  if (!Array.isArray(obj)) {
    return obj;
  }

  return JSON.stringify(obj);
};

const addKeysPrefix = (prefix, props) =>
  mapKeys(props, (value, key) => `${prefix}${key}`);

const flat = (props, separator = '.') =>
  reduce(props, (result, value, key) => {
    const usableValue = toValue(value);

    if (!isObject(usableValue)) {
      return {
        ...result,
        [key]: usableValue,
      };
    }

    const prefixed = addKeysPrefix(`${key}${separator}`, value);

    return {
      ...result,
      ...flat(prefixed, separator),
    };
  }, {});

const countPremium = (list) => list ? list.filter(i => i.featured).length : 0;

const searchProps = (state) => {
  const results = state.loadsSearch.results;
  const { shipments = [], total_shipments = 0 } = results || {};
  const similarResults = state.similarLoads.results || {};
  const skipSimilar = state.similarLoads.noneResults;

  const mainPremium = countPremium(shipments);
  const similarPremium = countPremium(similarResults.shipments);

  const hasBookingLoad = shipments.some(item => item.book_now);

  return {
    hasBookingLoad,
    total_count: parseFloat(total_shipments) + (skipSimilar ? 0 : parseFloat(similarResults.total_shipments)),
    main_count: parseFloat(total_shipments),
    similar_count: skipSimilar ? null : (parseFloat(similarResults.total_shipments)),
    premium_total_count: mainPremium + (skipSimilar ? 0 : similarPremium),
    premium_main_count: mainPremium,
    premium_similar_count: skipSimilar ? null : similarPremium,
  };
};

const getLoadEntry = (id, state, identity) => {
  let i = get(state, ['loadsSearch', 'itemsIndex', id]);
  return i || (identity && loadFromState(state, identity));
};


const getLoad = (id, state, identity) => {
  let i = getLoadEntry(id, state, identity);
  const isMain = get(i, 'identity.parentIdentity.name') === 'loadsSearch';

  if (!i) {
    return {id};
  }

  const isFresh = Boolean(get(state, ['loadsSearch', 'addedItemsFlatIndex', i.id]));

  let startIndex = (isMain && !isFresh)
    ? 1 + get(state.loadsSearch, 'addedItemsFlat.length', 0)
    : 1;

  const isSimilar = !isMain;

  const indexNum = isSimilar
    ? get(state, ['similarLoads', 'orderIndex', id])
    : get(state, ['loadsSearch', 'orderIndex', id]);

  const dho = getDistance({
    lat: get(state, 'loadsSearch.queryCompleted.from_lat'),
    lng: get(state, 'loadsSearch.queryCompleted.from_lng'),
  }, i.from_location);

  const dhd = getDistance({
    lat: get(state, 'loadsSearch.queryCompleted.to_lat'),
    lng: get(state, 'loadsSearch.queryCompleted.to_lng'),
  }, i.to_location);

  const {loadsSearch} = state;
  const deleted = Boolean(i.deleted || (loadsSearch.deletedIndex && loadsSearch.deletedIndex[i.id]));

  return {
    id: String(id),
    dhd,
    dho,
    isBookingLoad: i.book_now === true,
    company: i.company,
    from_city: i.from_city,
    from_state: i.from_state,
    to_city: i.to_city,
    to_state: i.to_state,
    load_size: i.load_size,
    weight: i.weight,
    target_price: i.target_price,
    distance: i.distance,
    age: parseFloat(i.age) / 1000 / 60,
    from_date: i.from_date_local,
    equipment: i.equipment.map(eq => humanLowerCaseToId[eq]).join(','),

    position: indexNum + startIndex,
    is_main: isMain,
    is_similar: !isMain,
    is_premium: i.featured,
    is_fresh: isFresh,
    is_removed: deleted,
    idMediumkey: i.identity.mediumkey,
  };
};

export {flat, searchProps, getLoad, getLoadEntry};



// WEBPACK FOOTER //
// ./src/misc/metrics/utils.js